import script from "./VillesView.vue?vue&type=script&setup=true&lang=js"
export * from "./VillesView.vue?vue&type=script&setup=true&lang=js"

import "./VillesView.vue?vue&type=style&index=0&id=594babe1&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-594babe1"]])

export default __exports__